// @flow
import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actionTypes from 'store/results/actionTypes';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import { getResultsAction } from '../actions';

type Action = {
  type: actionTypes.GET_RESULTS,
  payload: {
    ts: string,
    bb: string,
    isVs3bet: boolean,
    isVs4bet: boolean,
    isEasy: boolean,
    gameTable: string,
    isPlo5: boolean,
    ggps: string,
  }
}

const chooseEndpoint = (
  isVs3Bet: boolean,
  isVs4Bet: boolean,
  isEasy: boolean,
  isPlo5: boolean,
  isFreeUser: boolean,
) => {
  if (isFreeUser) {
    return URL.GET_RESULTS_FREE;
  }
  if (isPlo5) {
    if (isVs3Bet) {
      return URL.GET_RESULTS_3BET_PLO5;
    }

    if (isVs4Bet) {
      return URL.GET_RESULTS_4BET_PLO5;
    }

    if (isEasy) {
      return URL.GET_RESULTS_EASY_PLO5;
    }

    return URL.GET_RESULTS_PLO5;
  }

  if (isVs3Bet) {
    return URL.GET_RESULTS_3BET;
  }

  if (isVs4Bet) {
    return URL.GET_RESULTS_4BET;
  }

  if (isEasy) {
    return URL.GET_RESULTS_EASY;
  }

  return URL.GET_RESULTS;
};

export function* getResults({ payload }: Action) {
  try {
    // eslint-disable-next-line max-len
    const requestPayload = payload.isPlo5 ? {
      ts: payload?.ts, bb: payload?.bb, game: payload?.gameTable, difficulty: payload?.difficulty,
    }
      : {
        ts: payload?.ts, bb: payload?.bb, gg: payload?.ggps === 'gg', difficulty: payload?.difficulty,
      };

    const res = yield call(api, {
      method: 'post',
      url: chooseEndpoint(payload.isVs3bet,
        payload.isVs4bet,
        payload.isEasy,
        payload.isPlo5,
        payload.isFreeUser),
      data: requestPayload,
    });

    yield put(getResultsAction.success({
      average: res?.data?.average,
      best: res?.data?.best,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(getResultsAction.error(e.response));
    if ((e.originalMessage || e.message) === 'your subscription does not allow you to use this service') {
      yield put(push('/profile'));
    }
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_RESULTS, getResults);
}
